export default __webpack_public_path__ + "static/media/EVENT212AARRAYr.33168533.png";